var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareOtherProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7958_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.725 3.51643C4.13449 4.57344 1.12842 9.12593 0.0044096 13.8262C-0.0315326 13.974 0.161248 14.064 0.256005 13.9451C2.70007 10.8897 6.03289 9.44078 10.6564 9.36689C10.8687 9.36367 11.0419 9.53395 11.0419 9.74278V12.5572C11.0419 12.8913 11.4536 13.0584 11.6922 12.8238L17.8873 6.73242C18.0376 6.58463 18.0376 6.34688 17.8873 6.20231L11.6954 0.110898C11.4536 -0.126847 11.0452 0.0434297 11.0452 0.377558V3.15018C11.0452 3.33331 10.908 3.48752 10.725 3.51643Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7958_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOtherProfile);
export default __webpack_public_path__ + "static/media/share-other-profile.b738a1ffb4c5e4baf4afa12667daeb66.svg";
export { ForwardRef as ReactComponent };